import {
  Backdrop,
  Box,
  Card,
  CardHeader,
  CircularProgress,
  Container,
  makeStyles,
} from "@material-ui/core";
import React, { useEffect } from "react";
import download from "js-file-download";
import Page from "src/components/Page";
import { apiUrl } from "src/Constants";
import { useDispatch, useSelector } from "react-redux";
import Moment from "moment";
import Swal from "sweetalert2";
import Axios from "axios";
import ReportSearchFormComponent from "src/components/forms/ReportSearchFormComponent";
import { getBrands } from "src/redux/actions/brand.action";
import { getYearList } from "src/redux/actions/purchaseRequest.action";
import { hasRole } from "src/utils/Auth";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export default function RefListReportComponent() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);

  const {
    result: { companyid, countryid, secureid },
  } = useSelector((state) => state.loginReducer);

  const brandReducer = useSelector((state) => state.brandReducer);
  const { years } = useSelector((state) => state.purchaseRequestReducer);
  const { authorizePR } = useSelector((state) => state.authorizationReducer);

  useEffect(() => {
    dispatch(getBrands(countryid, companyid, secureid));
    dispatch(getYearList());
    return () => {};
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <Page className={classes.root} title="Ref List">
      <Container maxWidth={false}>
        <Box mb={2}>
          <Card>
            <CardHeader
              subheader="For ref list report"
              title="Ref List Report"
            />
          </Card>
        </Box>
        <Box>
          <ReportSearchFormComponent
            formValue={{
              ROLE: hasRole(authorizePR.data, [
                "admin",
                "super-admin",
                "manager-purchasing-report",
                "staff-report",
              ])
                ? "staff"
                : "user",
              SECID: secureid,
              BUDGET_YEAR: null,
              COUNTRYID: countryid,
              COMPANYID: companyid,
              DATE_FROM: Moment(`11-01-2020`),
              DATE_TO: Moment(),
              PROJECT_CODE: null,
              BRANDID: "",
              DEPARTID: "",
            }}
            onSubmit={(value) => {
              handleToggle();
              Axios({
                url: `${apiUrl}/report/ref-list-report`,
                method: "POST",
                data: value,
                authorization: `Bearer ${localStorage.getItem("token")}`,
                responseType: "blob",
              })
                .then((res) => {
                  handleClose();
                  const filename =
                    "ref-list-report-" +
                    Moment().format("DD-MMM-YYYY_HHmmss") +
                    ".csv";
                  download(res.data, filename);
                })
                .catch((err) => {
                  handleClose();
                  Swal.fire("The system has error.", err.message, "error");
                });
            }}
            year={years.data}
            brand={brandReducer.result}
          />
        </Box>
        <Backdrop
          className={classes.backdrop}
          open={open}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Container>
    </Page>
  );
}
